import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Invoice_header from '../Header/Invoice_header';
import "../../styles/InvoiceEdit.css";
import back_arrow from "../../assets/svg/back-arrow.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import AsyncSelect from "react-select/async";
import "../../styles/invoice_addnew.css";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from '../../axiosInstance';
import tick_icon from "../../assets/svg/tick_icon.svg"
import submitted_icon from "../../assets/svg/approval-flow-submitted-icon.svg"
import cancel_icon from "../../assets/svg/approval-flow-cancel-icon.svg"
import deleted_icon from "../../assets/svg/approval-flow-deleted-icon.svg"
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import CommonFooter from '../../CommonFooter/CommonFooter';
import { FiPaperclip } from "react-icons/fi";
import { HiOutlineDownload } from "react-icons/hi";
import useAttachmentValidator from "../AttachmentValidator/AttachmentValidator";
import CostApproveRejectPopup from './CostApproveRejectPopup';
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from '../../CommonRemarkPopup/CommonRemarkPopup';
import SapCsvSafeInput from '../../CommonRemarksRestriction/SapCsvSafeInput';

const CostInvoiceViewPage = () => {

    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const { validateAttachments } = useAttachmentValidator();
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const invoice = state?.invoice || {};
    const [allCategories, setAllCategories] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [sapDetails, setSapDetails] = useState({});
    const [jobTypes, setJobTypes] = useState([]);
    const [summary, setSummary] = useState([]);
    const [isDraft, setIsDraft] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [projectId, setselectedprojectId] = useState(0);
    const [selectedChargeIds, setSelectedChargeIds] = useState({});
    const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
    const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [activeTab, setActiveTab] = useState('jobs'); // Default to 'jobs' ta
    const [showTimeline, setShowTimeline] = useState(true);
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [actionType, setActionType] = useState(""); // 'approved' or 'rejected'
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState('');
    const [vendorInvNumber, setVendorInvNumber] = useState("");
    const [vendorInvDate, setVendorInvDate] = useState("");
    const [ismodalOpen, setIsModalOpen] = useState(false);
    const [costHeaderRemarks, setCostHeaderRemarks] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [vendorSuggestions, setVendorSuggestions] = useState([]);
    const [showVendorSuggestions, setShowVendorSuggestions] = useState({});
    const [vendorInputValues, setVendorInputValues] = useState({});
    const [selectedVendorIds, setSelectedVendorIds] = useState({});
    const fileInputRef = useRef();
    const [selectedTaxCode, setSelectedTaxCode] = useState(null);
    const [taxInputValue, setTaxInputValue] = useState("");
    const [vendorAttachment, setVendorAttachment] = useState(null);
    const [invoiceMode, setInvoiceMode] = useState("");
    const [approvalData, setApprovalData] = useState(null);
    const [existingVendorAttachment, setExistingVendorAttachment] = useState("");
    const [isVendorAttachmentRemoved, setIsVendorAttachmentRemoved] = useState(false);
    const [showRemarkPopup, setShowRemarkPopup] = useState(false);
    const [remarkValue, setRemarkValue] = useState("");
    const [remarkMeta, setRemarkMeta] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [ffPlantCode, setFfPlantCode] = useState(null);
    const [divisionType, setDivisionType] = useState(null);

    const openModal = async (type) => {
        setActionType(type);

        const data = await fetchApprovalData(invoice.id);

        if (data) {
            setApprovalData(data);
            setModalOpen(true);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setComment("");
    };


    useEffect(() => {
        const fetchInvoiceData = async () => {
            if (invoice.id) {
                // setIsLoading(true);
                try {
                    // const response = await axios.get(
                    //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/edit/${invoice.id}`
                    // );

                    const response = await axiosInstance.get(
                        `invoice/edit_cost_invoice/${invoice.id}`
                    );

                    console.log("Invoice Response Edit Data", response.data);

                    if (response.data && response.data.success) {
                        const data = response.data.data;

                        console.log("Fetched invoice_details", data.invoice_details);
                        console.log("Fetched summary", data.summary);
                        console.log("Fetched line_items", data.line_items);
                        console.log("Fetched sap_details", data.sap_details);
                        console.log("Fetched Invoice_mode", data.invoice_details[0]?.invoice_mode);

                        setInvoiceDetails(data.invoice_details[0] || {});

                        setSapDetails(data.sap_details[0] || {});
                        setJobTypes(data.job_types || []);
                        setSummary(data.summary || []);
                        if (data.summary && data.summary.length > 0) {
                            setFfPlantCode(data.summary[0]?.ff_plant_id || null);
                            setDivisionType(data.summary[0]?.division_type?.toLowerCase() || null);
                        }
                        setselectedprojectId(data.invoice_details[0]?.project_id);
                        setVendorInvNumber(data.invoice_details[0]?.vendor_inv_number || "");
                        setVendorInvDate(data.invoice_details[0]?.vendor_inv_date || "");
                        setInvoiceMode(data.invoice_details[0]?.invoice_mode || "");
                        setExistingVendorAttachment(data.invoice_details[0]?.vendor_inv_attachment_url || "");
                        // Inside fetchInvoiceData, after setting other states:
                        setApprovalHistory(data.approval_history || []);

                        // Transform line items into categories format
                        const transformedCategories = data.line_items.map(item => {
                            const jobIdFromDetails = item.details.find(detail => detail.job_id)?.job_id || '';
                            const jobTypeFromDetails = item.details.find(detail => detail.job_type)?.job_type || '';
                            const quantityFromDetails = item.details.find(detail => detail.cost_unit_of_quantity)?.cost_unit_of_quantity || '0';
                            const jobtypeidFromDetails = item.details.find(detail => detail.job_type_id)?.job_type_id || '0';

                            return {
                                jobnumber: item.job_no,
                                accrual: item.accrual,
                                id: jobIdFromDetails,
                                jobTypeId: jobtypeidFromDetails,
                                jobType: jobTypeFromDetails,
                                quantity: quantityFromDetails,
                                rows: item.details.map(detail => ({
                                    project_id: detail.project_id,
                                    project_name: detail.project_name || "",
                                    // billingtype: detail.job_type || "",
                                    chargecode: detail.charge_code || "",
                                    description: detail.description || "",
                                    // unitQuantity: detail.unit_of_quantity || "",
                                    costunitQuantity: detail.cost_unit_of_quantity || "",
                                    jobTypeId: detail.job_type_id || 0,
                                    jobLineId: detail.job_line_id || 0,
                                    chargeId: detail.charge_id || 0,
                                    attachment: detail.attachment_url || "",
                                    existingAttachmentUrl: detail.attachment_url || "",
                                    uploadedFiles: [],
                                    supporting_document: detail.cost_supporting_doc ?? false,
                                    isChecked: false,
                                    vendor_name: detail.vendor_name || "",
                                    vendor_id: detail.vendor_id || 0,
                                    costRemarks: detail.cost_remarks || "",
                                    costAccrual: detail.cost_accrual || "",
                                    costRate: detail.cost_unit_of_rate || "",
                                    costNetTotal: detail.cost_net_total || "",
                                    costContractValue: detail.cost_contract_value || 0,
                                    po_wo_number: detail.cost_po_wo_number || null,
                                    po_wo_date: detail.cost_po_wo_date || null,
                                    vendor_inv_number: detail.vendor_inv_number || "",
                                    vendor_inv_date: detail.vendor_inv_date || "",
                                }))
                            };
                        });

                        setAllCategories(transformedCategories);

                        // Initialize inputValues with the charge codes from the data
                        const initialInputValues = {};
                        transformedCategories.forEach((category, catIndex) => {
                            initialInputValues[catIndex] = {};
                            category.rows.forEach((row, rowIndex) => {
                                initialInputValues[catIndex][rowIndex] = row.chargecode || "";
                            });
                        });
                        setInputValues(initialInputValues);

                        // Initialize selectedChargeIds with the charge ids from the data
                        const initialSelectedChargeIds = {};
                        transformedCategories.forEach((category, catIndex) => {
                            category.rows.forEach((row, rowIndex) => {
                                initialSelectedChargeIds[`${catIndex}_${rowIndex}`] = row.chargeId || 0;
                            });
                        });
                        setSelectedChargeIds(initialSelectedChargeIds);

                        const initialVendorInputValues = {};
                        const initialSelectedVendorIds = {};

                        transformedCategories.forEach((category, catIndex) => {
                            category.rows.forEach((row, rowIndex) => {
                                initialVendorInputValues[`${catIndex}_${rowIndex}`] = row.vendor_name || "";
                                initialSelectedVendorIds[`${catIndex}_${rowIndex}`] = row.vendor_id || 0;
                            });
                        });

                        setVendorInputValues(initialVendorInputValues);
                        setSelectedVendorIds(initialSelectedVendorIds);


                        // Set status flags
                        const status = data.invoice_details[0]?.approval_status?.toLowerCase();
                        setIsDraft(status === 'draft' || status === 'rejected');
                        setIsSubmitted(status === 'submitted' || status === 'approved' || status === 'completed' || status === 'rejected' || status === 're-submitted' || status === 'sap pushed' || status === 'final invoice');
                    }
                } catch (error) {
                    console.error("Error fetching invoice data:", error);
                }
                // finally {
                //     setIsLoading(false);
                // }
            }
        };

        fetchInvoiceData();
    }, [invoice]);

    useEffect(() => {
        if (!vendorInvNumber && !vendorInvDate) return;

        setAllCategories(prev =>
            prev.map(category => ({
                ...category,
                rows: category.rows.map(row => ({
                    ...row,
                    vendor_inv_number: vendorInvNumber,
                    vendor_inv_date: vendorInvDate
                }))
            }))
        );
    }, [vendorInvNumber, vendorInvDate]);



    const addRow = (categoryId) => {
        if (!isDraft) return; // Only allow adding rows for draft invoices

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: [
                            ...category.rows,
                            {
                                billingtype: "",
                                jobTypeId: category.rows[0]?.jobTypeId || "",
                                chargecode: "",
                                elements: "",
                                description: "",
                                jobLineId: "",
                                // unitQuantity: "",
                                costunitQuantity: "",
                                costRemarks: "",
                                costAccrual: "",
                                costRate: "",
                                costNetTotal: "",
                                po_wo_number: null,
                                po_wo_date: null,
                                costContractValue: "0",
                                attachment: "",
                                uploadedFiles: [],
                                isChecked: false,
                                vendor_inv_number: vendorInvNumber,
                                vendor_inv_date: vendorInvDate
                            },
                        ],
                    }
                    : category
            )
        );
    };

    const handleFileUpload = (e, categoryId, index, lineindex) => {
        const files = validateAttachments(e.target.files);
        if (!files.length) return;

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveAttachment = (categoryId, index, lineindex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    attachment: "",
                                    existingAttachmentUrl: "",
                                    uploadedFiles: []
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };



    // const handleInputChange = (e, categoryId, rowIndex, field) => {
    //     if (!isDraft) return; // Only allow input changes for draft invoices

    //     const { value } = e.target;

    //     setAllCategories(prevCategories =>
    //         prevCategories.map(category =>
    //             category.id === categoryId
    //                 ? {
    //                     ...category,
    //                     rows: category.rows.map((row, i) => {
    //                         if (i === rowIndex) {
    //                             const updatedRow = { ...row, [field]: value };

    //                             if (field === 'unitQuantity' || field === 'unitRatePrice') {
    //                                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
    //                                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
    //                                 updatedRow.netTotal = (quantity * rate).toString();
    //                             }

    //                             return updatedRow;
    //                         }
    //                         return row;
    //                     }),
    //                 }
    //                 : category
    //         )
    //     );
    // };


    const handleInputChange = (e, index, rowIndex, field) => {
        if (!isDraft) return;
        let value = e.target.value;

        if (field === "costRemarks") {
            value = value.replace(/,/g, "");
        }

        setAllCategories(prevCategories =>
            prevCategories.map((category, currentindex) => {
                if (currentindex === index) {
                    const updatedRows = category.rows.map((row, i) => {
                        if (i === rowIndex) {
                            const updatedRow = { ...row, [field]: value };

                            // Recalculate values when relevant fields change
                            if (field === 'salesunitQuantity' || field === 'salesRate') {
                                const Salesquantity = parseFloat(updatedRow.salesunitQuantity) || 0;
                                const salesRate = parseFloat(updatedRow.salesRate) || 0;
                                updatedRow.salesNetTotal = (Salesquantity * salesRate).toFixed(2);
                            }

                            if (field === 'costunitQuantity' || field === 'costRate') {
                                const Costquantity = parseFloat(updatedRow.costunitQuantity) || 0;
                                const costRate = parseFloat(updatedRow.costRate) || 0;
                                updatedRow.costNetTotal = (Costquantity * costRate).toFixed(2);
                            }

                            // Calculate profit whenever sales or cost changes
                            if (field === 'salesRate' || field === 'costRate' ||
                                field === 'costunitQuantity' || field === 'salesNetTotal' ||
                                field === 'costNetTotal') {
                                const salesTotal = parseFloat(updatedRow.salesNetTotal) || 0;
                                const costTotal = parseFloat(updatedRow.costNetTotal) || 0;
                                updatedRow.profitAmount = (salesTotal - costTotal).toFixed(2);
                                updatedRow.profitPercent = costTotal > 0
                                    ? (((salesTotal - costTotal) / costTotal) * 100).toFixed(2)
                                    : '0.00';
                            }

                            return updatedRow;
                        }
                        return row;
                    });

                    // Calculate category totals
                    const categoryTotals = updatedRows.reduce((acc, row) => {
                        return {
                            salesNetTotal: acc.salesNetTotal + (parseFloat(row.salesNetTotal) || 0),
                            costNetTotal: acc.costNetTotal + (parseFloat(row.costNetTotal) || 0),
                            profitAmount: acc.profitAmount + (parseFloat(row.profitAmount) || 0)
                        };
                    }, { salesNetTotal: 0, costNetTotal: 0, profitAmount: 0 });

                    const profitPercent = categoryTotals.costNetTotal > 0
                        ? ((categoryTotals.profitAmount / categoryTotals.costNetTotal) * 100).toFixed(2)
                        : '0.00';

                    return {
                        ...category,
                        rows: updatedRows,
                        salesNetTotal: categoryTotals.salesNetTotal.toFixed(2),
                        costNetTotal: categoryTotals.costNetTotal.toFixed(2),
                        profitAmount: categoryTotals.profitAmount.toFixed(2),
                        profitPercent
                    };
                }
                return category;
            })
        );
    };

    const deleteRow = (categoryId, rowIndex) => {
        const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

        if (categoryIndex === -1) {
            return; // Category not found, should not happen but good to check
        }

        const category = allCategories[categoryIndex];

        if (category.rows.length <= 1) {
            toast.error("At least one row must remain, cannot delete.");
            return;
        }

        setAllCategories(prevCategories =>
            prevCategories.map(cat => {
                if (cat.id === categoryId) {
                    const newRows = [...cat.rows];
                    newRows.splice(rowIndex, 1);
                    return { ...cat, rows: newRows };
                }
                return cat;
            })
        );

        setInputValues(prevInputValues => {
            const newInputValues = { ...prevInputValues };
            if (newInputValues[categoryIndex]) {
                const rows = { ...newInputValues[categoryIndex] };
                delete rows[rowIndex];
                const shiftedRows = {};
                Object.keys(rows).forEach(key => {
                    const keyNum = Number(key);
                    shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
                });
                newInputValues[categoryIndex] = shiftedRows;
            }
            return newInputValues;
        });

        setSelectedChargeIds(prevSelectedChargeIds => {
            const newSelectedChargeIds = {};
            Object.keys(prevSelectedChargeIds).forEach(key => {
                const [catIndexStr, rowIdxStr] = key.split('_');
                const catIndex = Number(catIndexStr);
                const rowIdx = Number(rowIdxStr);

                if (catIndex === categoryIndex) {
                    if (rowIdx < rowIndex) {
                        newSelectedChargeIds[key] = prevSelectedChargeIds[key];
                    } else if (rowIdx > rowIndex) {
                        newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
                    }
                    // If rowIdx === rowIndex, we simply skip it (the deleted row)
                } else {
                    newSelectedChargeIds[key] = prevSelectedChargeIds[key];
                }
            });
            return newSelectedChargeIds;
        });

        setVendorInputValues(prevVendorInputValues => {
            const newVendorInputValues = {};
            Object.keys(prevVendorInputValues).forEach(key => {
                const [catIndexStr, rowIdxStr] = key.split('_');
                const catIndex = Number(catIndexStr);
                const rowIdx = Number(rowIdxStr);

                if (catIndex === categoryIndex) {
                    if (rowIdx < rowIndex) {
                        newVendorInputValues[key] = prevVendorInputValues[key];
                    } else if (rowIdx > rowIndex) {
                        newVendorInputValues[`${catIndex}_${rowIdx - 1}`] = prevVendorInputValues[key];
                    }
                } else {
                    newVendorInputValues[key] = prevVendorInputValues[key];
                }
            });
            return newVendorInputValues;
        });

        setSelectedVendorIds(prevSelectedVendorIds => {
            const newSelectedVendorIds = {};
            Object.keys(prevSelectedVendorIds).forEach(key => {
                const [catIndexStr, rowIdxStr] = key.split('_');
                const catIndex = Number(catIndexStr);
                const rowIdx = Number(rowIdxStr);

                if (catIndex === categoryIndex) {
                    if (rowIdx < rowIndex) {
                        newSelectedVendorIds[key] = prevSelectedVendorIds[key];
                    } else if (rowIdx > rowIndex) {
                        newSelectedVendorIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedVendorIds[key];
                    }
                } else {
                    newSelectedVendorIds[key] = prevSelectedVendorIds[key];
                }
            });
            return newSelectedVendorIds;
        });

        setSuggestionsMap(prev => {
            const newMap = { ...prev };
            if (newMap[categoryIndex]) {
                const rows = { ...newMap[categoryIndex] };
                delete rows[rowIndex];
                const shiftedRows = {};
                Object.keys(rows).forEach(key => {
                    const keyNum = Number(key);
                    shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
                });
                newMap[categoryIndex] = shiftedRows;
            }
            return newMap;
        });
    };


    // const handleUpdate = async (actionType) => {
    //     if (!isDraft) return; // Only allow submission for draft invoices

    //     for (let category of allCategories) {
    //         for (let row of category.rows) {
    //             const { chargecode, description, unitQuantity, unitRatePrice, netTotal } = row;

    //             if (!chargecode || !chargecode.trim()) {
    //                 toast.error("Charge Code is required");
    //                 return;
    //             }

    //             if (!description || !description.trim()) {
    //                 toast.error("Description of Charges is required");
    //                 return;
    //             }

    //             if (!unitQuantity || isNaN(unitQuantity)) {
    //                 toast.error("Unit Quantity is required");
    //                 return;
    //             }

    //             if (!unitRatePrice || isNaN(unitRatePrice)) {
    //                 toast.error("Unit Rate Price is required");
    //                 return;
    //             }

    //             if (!netTotal || isNaN(netTotal)) {
    //                 toast.error("Net Total is required");
    //                 return;
    //             }

    //         }
    //     }

    //     try {
    //         const jobs = allCategories.map((category, categoryIndex) => ({
    //             id: category.id,
    //             jobnumber: category.jobnumber,
    //             project_id: parseInt(projectId) || 0,
    //             job_type_id: category.rows[0]?.jobTypeId || 0,
    //             job_created_date: new Date().toISOString().split("T")[0],
    //             job_line: category.rows.map((row, rowIndex) => {
    //                 const attachmentKey = `${categoryIndex}_${rowIndex}`;
    //                 const hasNewFile = row.uploadedFiles?.length > 0;

    //                 return {
    //                     project_id: parseInt(projectId) || 0,
    //                     job_type_id: row.jobTypeId || 0,
    //                     charge_id: Array.isArray(selectedChargeIds[`${categoryIndex}_${rowIndex}`])
    //                         ? selectedChargeIds[`${categoryIndex}_${rowIndex}`]
    //                         : [selectedChargeIds[`${categoryIndex}_${rowIndex}`] || row.chargeId || 0],
    //                     description_of_charges: row.description || "",
    //                     unit_of_quantity: parseFloat(row.unitQuantity) || 0,
    //                     unit_of_rate: parseFloat(row.unitRatePrice) || 0,
    //                     net_total: parseFloat(row.netTotal) || 0,
    //                     accrual: parseFloat(row.accrualSplit) || 0,
    //                     attachment_key: attachmentKey,
    //                     ...(hasNewFile
    //                         ? {}
    //                         : row.existingAttachmentUrl && { existing_attachment_url: row.existingAttachmentUrl }),
    //                 };
    //             })
    //         }));

    //         const payload = {
    //             jobs,
    //             actions: [actionType],
    //             update_invoice: "1",
    //             invoice_id: invoice.id,
    //             approval_status: invoice.approval_status
    //         };

    //         const formData = new FormData();
    //         formData.append("data", JSON.stringify(payload));

    //         allCategories.forEach((category, categoryIndex) => {
    //             category.rows.forEach((row, rowIndex) => {
    //                 if (row.uploadedFiles?.length > 0) {
    //                     row.uploadedFiles.forEach(file => {
    //                         const attachmentKey = `${categoryIndex}_${rowIndex}`;
    //                         formData.append(`attachments[${attachmentKey}][]`, file);
    //                     });
    //                 }
    //             });
    //         });

    //         // const response = await axios.post(
    //         //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/save',
    //         //     formData,
    //         //     { headers: { 'Content-Type': 'multipart/form-data' } }
    //         // );

    //         const response = await axiosInstance.post(
    //             '/invoice/save',
    //             formData,
    //             { headers: { 'Content-Type': 'multipart/form-data' } }
    //         );

    //         if (response.data.success) {
    //             toast.success('Invoice updated successfully!');
    //             navigate(-1); // Go back to previous page
    //         } else {
    //             toast.error('Failed to update invoice: ' + (response.data.message || 'Unknown error'));
    //         }
    //     } catch (error) {
    //         console.error('Error updating invoice:', error);
    //         toast.error('An error occurred while updating the invoice');
    //     }
    // };


    const handleUpdate = async (action) => {
        if (!isDraft) return; // Only allow update for draft invoices
        if (isSaving || isSubmitting) return;

        for (let category of allCategories) {
            for (let row of category.rows) {
                const { chargecode, description, costunitQuantity, costRate, costNetTotal } = row;

                if (!chargecode || !chargecode.trim()) {
                    toast.error("Charge Code is required");
                    return;
                }

                if (!description || !description.trim()) {
                    toast.error("Description of Charges is required");
                    return;
                }

                if (!costunitQuantity || isNaN(costunitQuantity)) {
                    toast.error("Unit Quantity is required");
                    return;
                }

                if (!costRate || isNaN(costRate)) {
                    toast.error("Unit Rate Price is required");
                    return;
                }

                if (!costNetTotal || isNaN(costNetTotal)) {
                    toast.error("Net Total is required");
                    return;
                }
            }
        }

        if (action === "save") {
            setIsSaving(true);
        } else {
            setIsSubmitting(true);
        }

        try {
            const jobs = allCategories.map((category, categoryIndex) => ({
                id: category.id,
                jobnumber: category.jobnumber,
                project_id: category.rows[0]?.project_id,
                job_type_id: category.rows[0]?.jobTypeId || 0,
                job_created_date: new Date().toISOString().split("T")[0],
                ff_plant_id: ffPlantCode,
                job_line: category.rows.map((row, rowIndex) => {
                    const attachmentKey = `${categoryIndex}_${rowIndex}`;
                    const hasNewFile = row.uploadedFiles?.length > 0;

                    return {
                        job_line_id: row.jobLineId || undefined, 
                        project_id: row.project_id,
                        job_type_id: row.jobTypeId,
                        charge_id: selectedChargeIds[attachmentKey] || 0,
                        description_of_charges: row.description || "",
                        vendor_inv_number: row.vendor_inv_number || "",
                        vendor_inv_date: row.vendor_inv_date || "",
                        // unit_of_quantity: parseFloat(row.unitQuantity) || 0,
                        vendor_id: selectedVendorIds[attachmentKey] || 0,
                        unit_of_quantity: parseFloat(row.costunitQuantity) || 0,
                        unit_of_rate: parseFloat(row.costRate) || 0,
                        net_total: parseFloat(row.costNetTotal) || 0,
                        accrual: parseFloat(row.costAccrual) || 0,
                        remarks: row.costRemarks || "",
                        po_wo_number: row.po_wo_number || null,
                        po_wo_date: row.po_wo_date || null,
                        contract_value: parseFloat(row.costContractValue) || 0,
                        attachment_key: { cost: attachmentKey },
                        ...(hasNewFile
                            ? {}
                            : row.existingAttachmentUrl && {
                                existing_cost_attachment_url: row.existingAttachmentUrl,
                            }),
                    };
                }),
            }));

            const invoice_meta = {};

            if (action === "submit") {
                allCategories.forEach(category => {
                    category.rows.forEach(row => {
                        if (row.vendor_inv_number) {
                            invoice_meta[row.vendor_inv_number] = {
                                remarks: costHeaderRemarks || "",
                                tax_code: selectedTaxCode?.value || null
                            };
                        }
                    });
                });
            }

            const payload = {
                vendors: [
                    {
                        jobs,
                        actions: [action],
                        generate_invoice: "0",
                        update_invoice: "1",
                        invoice_id: invoice.id,
                        invoice_target: "cost",
                        approval_status: invoice.approval_status,
                        vendor_ids: [invoiceDetails.vendor_id],
                        invoice_mode: invoiceMode,
                        division_type: divisionType,
                        invoice_meta,
                        ...(!isVendorAttachmentRemoved &&
                            existingVendorAttachment &&
                            !vendorAttachment && {
                            existing_vendor_attachment_url: existingVendorAttachment
                        })
                    }
                ]
            };
            const formData = new FormData();


            // ✅ Append uploaded files properly
            allCategories.forEach((category, categoryIndex) => {
                category.rows.forEach((row, rowIndex) => {
                    if (row.uploadedFiles?.length > 0) {
                        const attachmentKey = `${categoryIndex}_${rowIndex}`;
                        row.uploadedFiles.forEach((file) => {
                            formData.append(`attachments[${attachmentKey}][]`, file);
                        });
                    }
                });
            });

            const vendorId = invoiceDetails.vendor_id;
            const vendorKey = `${vendorId}_${vendorInvNumber}`;

            if (vendorAttachment) {
                formData.append(`vendor_attachment[${vendorKey}]`, vendorAttachment);
            }

            formData.append("data", JSON.stringify(payload));

            const response = await axiosInstance.post(
                "/invoice/cost_invoice_save",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data.success) {
                toast.success("Cost Invoice updated successfully!");
                navigate(-1);
            } else {
                toast.error("Failed to update invoice: " + (response.data.message || "Unknown error"));
            }
        } catch (error) {
            console.error("Error updating invoice:", error);
            toast.error("An error occurred while updating the invoice");
        } finally {
            setIsSaving(false);
            setIsSubmitting(false);
        }
    };

    const handleOpenSubmitModal = () => {
        if (!vendorAttachment && (!existingVendorAttachment || isVendorAttachmentRemoved)) {
            toast.error("Vendor Attachment is mandatory");
            return;
        }

        setIsModalOpen(true);
    };

    const handleInvoiceAction = async (data) => {
        if (isActionLoading) return;
        if (!data.comments?.trim()) {
            toast.error("Comment is required");
            return;
        }
        setIsActionLoading(true);
        const payload = {
            invoice_id: invoice.id,
            // project_id: invoiceDetails.project_id,
            vendor_id: invoiceDetails.vendor_id,
            module: "3",
            invoice_type: "cost",
            comments: data.comments,
            status: actionType,
            cost_header_remarks: data.cost_header_remarks,
            ...(data.tax_code && { tax_code: data.tax_code }),
            // ...(data.plant_code && { plant_code: data.plant_code })
        };

        console.log("payload checkkkkkkkkk", payload);

        try {
            const response = await axiosInstance.post(`/approve_reject_btns`, payload);

            console.log("approve_reject response", response);

            if (response.status === 200) {
                toast.success(`Invoice ${actionType} successfully!`);
                navigate(-1);
            } else {
                toast.error(`Failed to ${actionType} invoice: ${response.data.message || 'Unknown error'}`);
            }

        } catch (error) {
            console.error(`Error ${actionType} invoice:`, error);
            toast.error(`An error occurred while ${actionType} the invoice`);
        } finally {
            setIsActionLoading(false);
            closeModal();
        }
    };


    const calculateCategoryTotals = (category) => {
        const totals = {
            quantity: 0,
            rate: 0,
            netValue: 0
        };

        category.rows.forEach(row => {
            totals.quantity += parseFloat(row.unitQuantity) || 0;
            totals.rate += parseFloat(row.unitRatePrice) || 0;
            totals.netValue += parseFloat(row.netTotal) || 0;
        });

        return totals;
    };

    const fetchSuggestions = async (searchTerm = "", rowIndex, index) => {
        try {
            setSuggestionsMap([]);

            // const response = await axios.get(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
            //     {
            //         params: {
            //             term: searchTerm
            //         }
            //     }
            // );

            const response = await axiosInstance.get(
                `/getnonprojectcostchargecodes`,
                {
                    params: {
                        term: searchTerm
                    }
                }
            );

            if (response.data?.chargecodes) {

                const newSuggestions = response.data?.chargecodes || [];
                setSuggestionsMap(prev => {
                    const updated = { ...prev };
                    if (!updated[index]) updated[index] = {}; // initialize if empty
                    updated[index][rowIndex] = newSuggestions;
                    console.log("Updated suggestionsMap:", updated);
                    return updated;
                });

                setShowSuggestionsMap(prev => ({
                    ...prev,
                    [`${index}_${rowIndex}`]: true,
                }));
            }
        } catch (err) {
            console.error("Failed to fetch suggestions", err);

            setSuggestionsMap(prev => {
                const updated = { ...prev };
                if (!updated[index]) updated[index] = {};
                updated[index][rowIndex] = []; // clear only that one
                return updated;
            });

            setShowSuggestionsMap(prev => ({
                ...prev,
                [`${index}_${rowIndex}`]: false,
            }));
        }
    };

    const handleDownload = async (attachmentUrl) => {
        try {
            // Check if the URL is valid
            if (!attachmentUrl) {
                toast.error("No attachment available");
                return;
            }

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = attachmentUrl;

            // Extract filename from URL or use a default name
            const fileName = attachmentUrl.split('/').pop() || 'document';
            link.setAttribute('download', fileName);

            // Append to DOM, trigger click, then remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error('Failed to download file');
        }
    };

    const fetchApprovalData = async (invoiceId) => {
        try {
            const response = await axiosInstance.post('/invoice/inv_approval_data', {
                invoice_id: invoiceId
            });

            if (response.data?.success) {
                return response.data.data;
            } else {
                toast.error(response.data?.message || "Failed to fetch approval data");
                return null;
            }
        } catch (error) {
            console.error("Approval data error:", error);
            toast.error("Error fetching approval data");
            return null;
        }
    };


    const historyData = [
        { status: 'Approved', name: 'Purushothaman', id: 'M200', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },
        { status: 'Approved', name: 'Jason Statham', id: 'M186', date: 'May 23, 2023 at 04:30 PM' },

    ];

    if (!showTimeline) return null;

    const fetchVendorSuggestions = async (searchTerm = "") => {
        try {
            const response = await axiosInstance.get(
                "/vendor/autosuggestion",
                { params: { term: searchTerm } }
            );
            return response.data?.autosuggestion || [];
        } catch (error) {
            console.error("Failed to fetch vendor suggestions:", error);
            return [];
        }
    };

    const handleRemoveVendorAttachment = () => {
        setVendorAttachment(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const loadTaxCodes = async (inputValue) => {
        try {
            const response = await axiosInstance.get("/projects/get_tax_code", {
                params: { term: inputValue || '' },
            });

            return response.data?.autosuggestion || [];
        } catch (error) {
            console.error("Tax code load error:", error);
            return [];
        }
    };

    const handleSubmitWithValidation = () => {
        setIsModalOpen(false);
        handleUpdate("submit");
    };

    const handleConsolidatedCostAttachment = async () => {
        try {
            const response = await axiosInstance.post(
                "/invoice_consolidate_pdf",
                {
                    id: invoice.id,
                    attachment_type: "cost",
                }
            );

            if (response.data.status === "success") {
                window.open(response.data.file_url, "_blank");
            } else {
                toast.error(response.data.message || "Failed to fetch Cost PDF");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to download Consolidated Cost PDF");
        }
    };

    const openCostRemarkPopup = (rowIndex, lineIndex, value) => {
        setRemarkMeta({ rowIndex, lineIndex, type: "cost" });
        setRemarkValue(value || "");
        setShowRemarkPopup(true);
    };

    const handleSaveRemark = (updatedValue) => {
        if (!remarkMeta) return;

        const { rowIndex, lineIndex, type } = remarkMeta;

        if (type === "cost") {
            handleInputChange(
                { target: { value: updatedValue } },
                rowIndex,
                lineIndex,
                "costRemarks"
            );
        }

        setShowRemarkPopup(false);
    };

    return (
        <>
            <Invoice_header onSearch={null} disableSearch={true} />
            <div className='invoice_module'>
                <div className="invoice-module-header">
                    <div className="invoice-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{invoice.inv_number}</p>
                    </div>
                    <div className="invoice-module_header_right">
                        {/* {!isDraft && (
                            <button className="edit_btn" onClick={() => navigate(-1)} >
                                Cancel
                            </button>
                        )} */}
                        {isDraft && (
                            <>
                                {/* <button className="edit_btn" onClick={() => navigate(-1)} >
                                    Cancel
                                </button> */}
                                <button className="edit_btn" onClick={() => handleUpdate("save")} disabled={isSaving || isSubmitting}>
                                    {isSaving ? "Saving..." : "Save"}
                                </button>
                                <button className="edit_btn" onClick={handleOpenSubmitModal} disabled={isSaving || isSubmitting}>
                                    Submit
                                </button>
                                {ismodalOpen && (
                                    <div className="modal" onClick={() => setIsModalOpen(false)}>
                                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                            <h3>Remarks to Vendor</h3>
                                            <SapCsvSafeInput
                                                as="textarea"
                                                value={costHeaderRemarks}
                                                onChange={setCostHeaderRemarks}
                                                maxLength={80}
                                                placeholder="Enter your Remarks..."
                                            />
                                            <p style={{ fontSize: "12px", textAlign: "right", color: "#555" }}>
                                                {costHeaderRemarks.length}/80
                                            </p>
                                            {invoiceMode === "NON_PO" && (
                                                < div style={{ marginTop: "5px", width: "100%" }}>
                                                    <label style={{ fontSize: "13px", fontWeight: 500 }}>
                                                        Tax Code
                                                    </label>

                                                    <AsyncSelect
                                                        value={selectedTaxCode}
                                                        inputValue={taxInputValue}
                                                        onInputChange={(value) => setTaxInputValue(value)}
                                                        onChange={(selected) => setSelectedTaxCode(selected)}
                                                        loadOptions={loadTaxCodes}
                                                        menuShouldBlockScroll={true}
                                                        menuPlacement="top"
                                                        placeholder="Search tax code..."
                                                        cacheOptions
                                                        defaultOptions
                                                        isClearable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                width: '100%',
                                                                height: '37px',
                                                                borderRadius: '12px',
                                                                fontSize: '13px',
                                                                fontFamily: 'Work Sans',
                                                                borderColor: state.isFocused ? '#0747A6' : '#D0D6DF',
                                                                boxShadow: state.isFocused ? '0 0 0 1px #0747A6' : 'none',
                                                            }),
                                                            container: (base) => ({
                                                                ...base,
                                                                width: '100%',
                                                                marginTop: '6px',
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: '13px',
                                                                fontFamily: 'Work Sans',
                                                            }),
                                                            menuPortal: (base) => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                            }),
                                                        }}
                                                        components={{
                                                            DropdownIndicator: null,
                                                            IndicatorSeparator: null,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <div className="modal-buttons">
                                                <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                                                <button onClick={() => handleSubmitWithValidation()}
                                                    disabled={isSaving || isSubmitting}>
                                                    {isSubmitting ? "Submitting..." : "Submit"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        {isSubmitted && invoiceDetails.approve_reject_btn === true && (
                            <>
                                <button className="reject_btn" onClick={() => openModal('rejected')}>
                                    Reject
                                </button>
                                <button className="approve_btn" onClick={() => openModal('approved')}>
                                    Approve
                                </button>
                            </>
                        )}

                        {isModalOpen && (
                            <CostApproveRejectPopup
                                isOpen={isModalOpen}
                                onClose={closeModal}
                                onSubmit={handleInvoiceAction}
                                actionType={actionType}
                                invoice={{ approvalData }}
                                isLoading={isActionLoading}
                            />

                        )}

                    </div>
                </div>

                <div className='invoice-module-details'>
                    <div className='invoice-module-job-details'>
                        <p className='invoice-module-invoice-details-header'>Invoice details</p>
                        <div className='invoice-module-main-details-grid' style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
                            <div className='invoice-module-details-grid'>
                                <p className='invoice-module-invoice-details-label'>Invoice No</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.inv_number}</p>

                                <p className='invoice-module-invoice-details-label'>Project</p>
                                <p className='invoice-module-invoice-details-value'> {invoiceDetails.project_name || "-"}</p>

                                <p className='invoice-module-invoice-details-label'>Vendor</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.vendor_name}</p>

                                <p className='invoice-module-invoice-details-label'>Period</p>
                                <p className='invoice-module-invoice-details-value'>Monthly</p>

                                <p className='invoice-module-invoice-details-label'>Created Date</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.created_date}</p>

                                <p className='invoice-module-invoice-details-label'>Status</p>
                                <p className='invoice-module-invoice-details-value'>
                                    <span className={`status-badge ${invoice.approval_status}`}>
                                        {invoice.approval_status}
                                    </span>
                                </p>

                                {/* {!["draft", "submitted"].includes(invoice.approval_status?.toLowerCase()) && (
                                    <>
                                        <p className='invoice-module-invoice-details-label'>Plant Code</p>
                                        <p className='invoice-module-invoice-details-value'>
                                            {invoiceDetails.plant_code || '-'}
                                        </p>
                                    </>
                                )} */}  
                            </div>

                            {invoice.approval_status?.toLowerCase() === 'submitted' && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        {invoiceMode === "NON_PO" && (
                                            <>
                                                <p className="invoice-module-invoice-details-label">Tax Code</p>
                                                <p className="invoice-module-invoice-details-value">
                                                    {invoiceDetails.tax_code || "-"}
                                                </p>
                                            </>
                                        )}

                                        <p className='invoice-module-invoice-details-label'>Remarks</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.cost_header_remarks ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                    </div>
                                </>
                            )}

                            {invoice.approval_status?.toLowerCase() === 'final invoice' && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        <p className='invoice-module-invoice-details-label'>Payment Invoice No</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.payment_inv_number ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Purchase Invoice No</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.purchase_inv_number ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Net Value</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.net_value ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Purchase Invoice Date</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.purchase_inv_date ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                    </div>
                                </>
                            )}
                        </div>



                        <div className='invoice-module-job-types'>
                            <div className='job-types-content'>
                                <p className='invoice-module-invoice-details-header'>Job types - {jobTypes.length}</p>
                                <div className='job-types-buttons'>
                                    {jobTypes.map((jobType, index) => (
                                        <button key={index} className='invoice-module-invoice-details-data'>
                                            {jobType.job_type_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="invoice_module_project">
                            <div className="invoice-module-project-summary">
                                <p className="invoice-module-summary-summary">Summary</p>
                                <table className="invoice-module-summary-table">
                                    <thead>
                                        <tr>
                                            <th>Jobs</th>
                                            <th>Quantity</th>
                                            <th>Rate</th>
                                            <th>Net Value</th>
                                        </tr>
                                    </thead>
                                    {summary.map((item, index) => (
                                        <tr key={index}>
                                            <td>Job No: {item.job_no}</td>
                                            <td>{item.cost_unit_of_quantity}</td>
                                            <td>{item.cost_unit_of_rate}</td>
                                            <td>{item.cost_net_total}</td>
                                        </tr>
                                    ))}
                                    <tr className="total-row">
                                        <td>Total</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.cost_unit_of_quantity || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.cost_unit_of_rate || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.cost_net_total || 0), 0)}</td>
                                    </tr>
                                </table>
                            </div>

                        </div>

                        <div style={{
                            display: 'flex',
                            gap: '20px',
                            marginBottom: '20px',
                            fontFamily: 'Work Sans, sans-serif',
                        }}>
                            {/* Vendor Invoice No */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <p style={{ margin: 0, fontSize: '12px', fontWeight: 600, fontFamily: 'Work Sans' }}>
                                    Vendor Invoice No
                                </p>
                                <input
                                    type="text"
                                    placeholder="Enter Vendor No..."
                                    value={vendorInvNumber}
                                    onChange={(e) => setVendorInvNumber(e.target.value)}
                                    //  disabled={!isDraft}
                                    disabled={true}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        outline: 'none',
                                        margin: '0px',
                                        width: '300px',
                                        height: '40px',
                                        fontFamily: 'Work Sans'
                                    }}
                                />
                            </div>

                            {/* Vendor Invoice Date */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <p style={{ margin: 0, fontSize: '12px', fontWeight: 600, fontFamily: 'Work Sans' }}>
                                    Vendor Invoice Date
                                </p>
                                <input
                                    type="date"
                                    value={vendorInvDate}
                                    onChange={(e) => setVendorInvDate(e.target.value)}
                                    // disabled={!isDraft} 
                                    disabled={true}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        outline: 'none',
                                        margin: '0px',
                                        width: '300px',
                                        height: '40px',
                                        fontFamily: 'Work Sans'
                                    }}
                                />
                            </div>

                            {/* Vendor Attachment */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <p style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    fontFamily: 'Work Sans',
                                    color: '#19324C'
                                }}>
                                    Vendor Attachment <span style={{ color: 'red' }}>*</span>
                                </p>

                                {/* ✅ Existing Attachment */}
                                {!isVendorAttachmentRemoved && existingVendorAttachment && !vendorAttachment && (
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        border: "1px solid #ccc",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        width: "fit-content"
                                    }}>
                                        <a
                                            href={existingVendorAttachment}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#007BFF", fontSize: "13px" }}
                                        >
                                            View Attachment
                                        </a>

                                        {isDraft && (
                                            <span
                                                style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
                                                onClick={() => {
                                                    setIsVendorAttachmentRemoved(true);
                                                    setExistingVendorAttachment("");
                                                }}
                                            >
                                                ✖
                                            </span>
                                        )}
                                    </div>
                                )}

                                {/* ✅ New Uploaded File */}
                                {vendorAttachment && (
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        border: "1px solid #ccc",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        width: "fit-content"
                                    }}>
                                        <span
                                            style={{
                                                maxWidth: "200px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                display: "inline-block",
                                                fontSize:'13px'
                                            }}
                                            title={vendorAttachment.name}
                                        >
                                            {vendorAttachment.name}
                                        </span>
                                        <span
                                            style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
                                            onClick={() => setVendorAttachment(null)}
                                        >
                                            ✖
                                        </span>
                                    </div>
                                )}

                                {/* ✅ Upload Button */}
                                {isDraft && (!existingVendorAttachment || isVendorAttachmentRemoved) && !vendorAttachment && (
                                    <label style={{
                                        border: "1px dashed #aaa",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        width: "fit-content",
                                        display: "flex",              
                                        alignItems: "center",         
                                        gap: "6px",                   
                                        fontSize: "13px",
                                        fontFamily: "Work Sans",
                                        color: "#19324C",
                                        margin:'0px'
                                    }}>
                                        <img src={upload_icon} />
                                        Upload
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            onChange={(e) => {
                                                const files = validateAttachments(e.target.files);

                                                if (!files.length) return;

                                                const file = files[0];
                                                setVendorAttachment(file);
                                            }}
                                        />
                                    </label>
                                )}
                            </div>

                        </div>
                    </div>
                </div>


                <div className="invoice_popup_categories">
                    {isSubmitted && (
                        <div className="invoice-module-wrapper">

                            {/* LEFT SIDE BUTTONS */}
                            <div className="invoice-module-button">
                                <button
                                    className={`edit_btn ${activeTab === 'jobs' ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab('jobs')}
                                >
                                    Jobs
                                </button>

                                <button
                                    className={`edit_btn ${activeTab === 'approval' ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab('approval')}
                                >
                                    Approval Flow
                                </button>
                            </div>

                            {/* RIGHT SIDE BUTTON */}
                            {/* <div className="invoice-module-actions">
                                <button
                                    className="consolidated-btn-viewpage"
                                    onClick={handleConsolidatedCostAttachment}
                                >
                                    <HiOutlineDownload size={16} style={{ marginRight: "6px" }} />
                                    Consolidated Cost PDF
                                </button>
                            </div> */}
                        </div>
                    )}
                    {/* {isDraft && (
                        <p className="invoice-module-summary-summary">Jobs</p>
                    )} */}
                    {(activeTab === 'jobs') && (
                        <div>
                            {allCategories.map((category, index) => {
                                const totals = calculateCategoryTotals(category);
                                return (
                                    <div key={category.id} style={{ marginTop: '30px' }} className="invoice_popup_outercategory">
                                        <div className="invoice_popup_category_header">
                                            <div className="category_name_left">
                                                <span className="category_name">Job No: {category.jobnumber}</span>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                gap: "12px",
                                                fontSize: '12px',
                                                flexWrap: "wrap"
                                            }}>
                                                {/* COST BOX */}
                                                <div style={{
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "8px",
                                                    padding: "12px 16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    width: 'auto',
                                                    height: '30px',
                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                                }}>
                                                    <span style={{ color: "#007bff", fontWeight: "600" }}>COST : </span>
                                                    <span style={{ color: "#000" }}>
                                                        Accrual : ₹ {category.rows.reduce((sum, row) => sum + (parseFloat(row.costAccrual) || 0), 0).toLocaleString()}
                                                    </span>
                                                    <span style={{
                                                        width: "1px",
                                                        backgroundColor: "#ccc",
                                                        alignSelf: "stretch"
                                                    }}></span>
                                                    <span style={{ color: "#000" }}>
                                                        Net Total : ₹ {category.rows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0).toLocaleString()}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="invoice_popup_category_subheader">
                                            <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                                <div className="table-container">
                                                    <table className="invoice_table">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="14" style={{ padding: '10px', color: '#097BED', backgroundColor: '#E0EFFF' }}>COST</th>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>CHARGE CODE</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>DESCRIPTION</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>VENDOR</th>
                                                                <th style={{ backgroundColor: '#E0EFFF' }}>Vendor Inv NO </th>
                                                                <th style={{ backgroundColor: '#E0EFFF' }}>Vendor Inv Date</th>
                                                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                                                <th style={{ padding: '10px', backgroundColor: '#E0EFFF', textAlign: 'center' }}>REMARKS</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>ACCRUAL SPLIT</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>CONTRACT VALUE</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>QUANTITY</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>RATE</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>NET TOTAL</th>
                                                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>ATTACHMENT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {category.rows.map((row, lineindex) => (
                                                                <tr key={lineindex}>
                                                                    {/* <td>
                                                            <input 
                                                                type="checkbox" 
                                                                disabled={!isDraft}
                                                            />
                                                        </td> */}
                                                                    <td style={{ position: "relative" }}>
                                                                        <input
                                                                            style={{ margin: '0px' }}
                                                                            type="text"
                                                                            disabled={!isDraft}
                                                                            // value={inputValues[index]?.[lineindex] || ""}
                                                                            value={inputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                                                            onChange={(e) => {
                                                                                // console.log("canEditChargeDetailsssssssssss", canEditChargeDetails);
                                                                                // if (!canEditChargeDetails) return;
                                                                                const val = e.target.value;
                                                                                handleInputChange(e, index, lineindex, "chargecode");
                                                                                setInputValues((prev) => ({
                                                                                    ...prev,
                                                                                    [index]: {
                                                                                        ...prev[index],
                                                                                        [lineindex]: val,
                                                                                    },
                                                                                }));
                                                                                fetchSuggestions(val, lineindex, index);
                                                                            }}
                                                                            onFocus={() => {
                                                                                // if (!canEditChargeDetails) return;
                                                                                const list = suggestionsMap[index]?.[lineindex] || [];
                                                                                if (list.length > 0) {
                                                                                    const list = suggestionsMap[index]?.[lineindex] || [];
                                                                                    if (list.length > 0) {
                                                                                        setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                                                                    }
                                                                                }
                                                                            }}
                                                                            onBlur={() => {
                                                                                setTimeout(() => {
                                                                                    setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                                                                }, 200);
                                                                            }}
                                                                            className="invoice_small_input"
                                                                            placeholder="Search"
                                                                        // disabled={!canEditChargeDetails}
                                                                        />

                                                                        {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                                                            <ul
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: "white",
                                                                                    border: "1px solid #ccc",
                                                                                    zIndex: 999,
                                                                                    maxHeight: "150px",
                                                                                    overflowY: "auto",
                                                                                    margin: 0,
                                                                                    padding: 0,
                                                                                    listStyle: "none",
                                                                                }}
                                                                            >
                                                                                {suggestionsMap[index]?.[lineindex].map((item) => (
                                                                                    <li
                                                                                        key={item.value}
                                                                                        onMouseDown={() => {
                                                                                            const selected = item.label;
                                                                                            const chargeId = item.value;
                                                                                            const supporting_doc = item.value2; // new


                                                                                            setInputValues((prev) => ({
                                                                                                ...prev,
                                                                                                [index]: {
                                                                                                    ...prev[index],
                                                                                                    [lineindex]: selected,
                                                                                                },
                                                                                            }));

                                                                                            setSelectedChargeIds((prev) => ({
                                                                                                ...prev,
                                                                                                [`${index}_${lineindex}`]: chargeId
                                                                                            }));

                                                                                            handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));


                                                                                            // ✨ NEW PART: split and set description separately ✨
                                                                                            const splitParts = selected.split("-");
                                                                                            const chargeCodeOnly = splitParts[0] || "";
                                                                                            const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                                                            // Update charge code field value (CT002)
                                                                                            setInputValues((prev) => ({
                                                                                                ...prev,
                                                                                                [index]: {
                                                                                                    ...prev[index],
                                                                                                    [lineindex]: chargeCodeOnly,
                                                                                                },
                                                                                            }));

                                                                                            handleInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                                                            // Update description field value (TestCharge)
                                                                                            handleInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");


                                                                                            // 🔥 Update supporting doc flag in that row
                                                                                            setAllCategories(prev =>
                                                                                                prev.map((cat, catIndex) =>
                                                                                                    catIndex === index
                                                                                                        ? {
                                                                                                            ...cat,
                                                                                                            rows: cat.rows.map((row, rIndex) =>
                                                                                                                rIndex === lineindex
                                                                                                                    ? { ...row, supporting_document: !!supporting_doc }
                                                                                                                    : row
                                                                                                            ),
                                                                                                        }
                                                                                                        : cat
                                                                                                )
                                                                                            );

                                                                                        }}
                                                                                        style={{
                                                                                            padding: "8px",
                                                                                            cursor: "pointer",
                                                                                            borderBottom: "1px solid #eee",
                                                                                        }}
                                                                                    >
                                                                                        {item.label}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row.description}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                                                            className="invoice_small_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td style={{ position: 'relative' }}>
                                                                        <input
                                                                            type="text"
                                                                            disabled={!isDraft}
                                                                            className="contracts_small_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                                                            value={vendorInputValues[`${index}_${lineindex}`] || ""}
                                                                            onChange={async (e) => {
                                                                                const val = e.target.value;
                                                                                setVendorInputValues(prev => ({
                                                                                    ...prev,
                                                                                    [`${index}_${lineindex}`]: val,
                                                                                }));

                                                                                if (val.length >= 1) {
                                                                                    const suggestions = await fetchVendorSuggestions(val);
                                                                                    setVendorSuggestions(suggestions);
                                                                                    setShowVendorSuggestions(prev => ({
                                                                                        ...prev,
                                                                                        [`${index}_${lineindex}`]: true,
                                                                                    }));
                                                                                } else {
                                                                                    setShowVendorSuggestions(prev => ({
                                                                                        ...prev,
                                                                                        [`${index}_${lineindex}`]: false,
                                                                                    }));
                                                                                }
                                                                            }}
                                                                            onFocus={async () => {
                                                                                const val = vendorInputValues[`${index}_${lineindex}`] || "";
                                                                                if (val.length >= 1) {
                                                                                    const suggestions = await fetchVendorSuggestions(val);
                                                                                    setVendorSuggestions(suggestions);
                                                                                    setShowVendorSuggestions(prev => ({
                                                                                        ...prev,
                                                                                        [`${index}_${lineindex}`]: true,
                                                                                    }));
                                                                                }
                                                                            }}
                                                                            onBlur={() => {
                                                                                setTimeout(() => {
                                                                                    setShowVendorSuggestions(prev => ({
                                                                                        ...prev,
                                                                                        [`${index}_${lineindex}`]: false,
                                                                                    }));
                                                                                }, 200);
                                                                            }}
                                                                            placeholder="Search vendor"
                                                                        />

                                                                        {showVendorSuggestions[`${index}_${lineindex}`] && vendorSuggestions.length > 0 && (
                                                                            <ul
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: "white",
                                                                                    border: "1px solid #ccc",
                                                                                    zIndex: 999,
                                                                                    maxHeight: "150px",
                                                                                    overflowY: "auto",
                                                                                    margin: 0,
                                                                                    padding: 0,
                                                                                    listStyle: "none",
                                                                                }}
                                                                            >
                                                                                {vendorSuggestions.map((vendor) => (
                                                                                    <li
                                                                                        key={vendor.value}
                                                                                        onMouseDown={() => {
                                                                                            setVendorInputValues(prev => ({
                                                                                                ...prev,
                                                                                                [`${index}_${lineindex}`]: vendor.label,
                                                                                            }));
                                                                                            setSelectedVendorIds(prev => ({
                                                                                                ...prev,
                                                                                                [`${index}_${lineindex}`]: vendor.value,
                                                                                            }));
                                                                                            setShowVendorSuggestions(prev => ({
                                                                                                ...prev,
                                                                                                [`${index}_${lineindex}`]: false,
                                                                                            }));
                                                                                        }}
                                                                                        style={{
                                                                                            padding: "8px",
                                                                                            cursor: "pointer",
                                                                                            borderBottom: "1px solid #eee",
                                                                                        }}
                                                                                    >
                                                                                        {vendor.label}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="invoice_narrow_input_quantity"
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                            value={vendorInvNumber || ""}
                                                                            disabled

                                                                        />
                                                                    </td>

                                                                    {/* Vendor Invoice Date */}
                                                                    <td>
                                                                        <input
                                                                            type="date"
                                                                            className="invoice_narrow_input_quantity"
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                            value={vendorInvDate || ""}
                                                                            disabled

                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row.po_wo_number}
                                                                            onChange={(e) => {
                                                                                if (e.target.value.length <= 10) {
                                                                                    handleInputChange(e, index, lineindex, "po_wo_number");
                                                                                }
                                                                            }}
                                                                            className="invoice_narrow_input_quantity"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="date"
                                                                            value={row.po_wo_date}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "po_wo_date")}
                                                                            className="invoice_narrow_input_quantity"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <div
                                                                            className="table-tooltip-container"
                                                                            style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                value={row.costRemarks}
                                                                                onChange={(e) =>
                                                                                    handleInputChange(e, index, lineindex, "costRemarks")
                                                                                }
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === ",") e.preventDefault();
                                                                                }}
                                                                                className="invoice_small_input"
                                                                                style={{ margin: "0px", fontFamily: "Work Sans" }}
                                                                                disabled={!isDraft}
                                                                            />
                                                                            {isDraft && row.costRemarks?.trim() && (
                                                                                <SquarePen
                                                                                    size={16}
                                                                                    onClick={() =>
                                                                                        openCostRemarkPopup(index, lineindex, row.costRemarks)
                                                                                    }
                                                                                />
                                                                            )}

                                                                            <span className="add-contract-tooltip">
                                                                                {row.costRemarks}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.costAccrual || 0}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.costContractValue}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "costContractValue")}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.costunitQuantity}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "costunitQuantity")}
                                                                            className="invoice_narrow_input_quantity"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.costRate}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                            onChange={(e) => {
                                                                                handleInputChange(e, index, lineindex, "costRate");
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.costNetTotal}
                                                                            // readOnly
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="file_upload_wrapper">
                                                                            {/* Uploaded files */}
                                                                            {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                                                                <div className="uploaded_files">
                                                                                    {row.uploadedFiles.map((file, fileIndex) => (
                                                                                        <div key={fileIndex} className="uploaded_file_item">
                                                                                            <img
                                                                                                src={file.name.match(/\.(xls|xlsx)$/i) ? excel_icon : upload_icon}
                                                                                                alt="File"
                                                                                                className="file_icon"
                                                                                            />
                                                                                            <span className="file_name">{file.name}</span>
                                                                                            {isDraft && (
                                                                                                <button
                                                                                                    className="remove_file_btn"
                                                                                                    onClick={() => handleRemoveFile(category.id, index, lineindex, fileIndex)}
                                                                                                >
                                                                                                    ⨉
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}

                                                                            {/* Existing attachment from API */}
                                                                            {!row.uploadedFiles?.length && row.attachment && (
                                                                                <div className="attachment_view_section">
                                                                                    <a
                                                                                        href={row.attachment}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="view_link"
                                                                                    >
                                                                                        <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                                                                        <span className="view_text">View</span>
                                                                                    </a>
                                                                                    {isDraft && (
                                                                                        <button
                                                                                            className="remove_file_btn"
                                                                                            onClick={() => {
                                                                                                const updatedCategories = [...allCategories];
                                                                                                updatedCategories[index].rows[lineindex].attachment = null;
                                                                                                setAllCategories(updatedCategories);
                                                                                            }}
                                                                                        >
                                                                                            ⨉
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}

                                                                            {/* Upload option */}
                                                                            {isDraft && !row.uploadedFiles?.length && !row.attachment && (
                                                                                <label className="file_upload">
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple
                                                                                        onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                                                                        style={{ display: "none" }}
                                                                                    />
                                                                                    <img src={upload_icon} alt="Upload" className="upload_icon" />
                                                                                    <span className="upload_text">Upload{" "}
                                                                                        {row.supporting_document && (
                                                                                            <span style={{ color: "red" }}>(Required*)</span>
                                                                                        )}</span>
                                                                                </label>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            position: 'sticky',
                                                                            right: 0,
                                                                            background: 'white',
                                                                            zIndex: 1,
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}> */}
                                                                        {isDraft && (
                                                                            <button style={{ backgroundColor: 'white' }} onClick={() => deleteRow(category.id, lineindex)}>
                                                                                <img src={delete_icon} alt="Delete" className="delete_icon" />
                                                                            </button>
                                                                        )}
                                                                        {/* </AdditionalPermissionWrapper> */}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}>
                                                        {isDraft && (
                                                            <div className="static-delete-container">
                                                                {category.rows.map((row, index) => (
                                                                    <div key={index} className="static-delete-btn">
                                                                        <button onClick={() => deleteRow(category.id, index)}>
                                                                            <img src={delete_icon} alt="Delete" className="delete_icon" />
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </AdditionalPermissionWrapper> */}

                                                </div>

                                                {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}> */}
                                                {isDraft && (
                                                    <div
                                                        className="add_new_row"
                                                        onClick={() => addRow(category.id)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="add_new_row_popup">
                                                            <img src={plus_icon} alt="" />
                                                            Add Row
                                                        </span>
                                                    </div>
                                                )}
                                                {/* </AdditionalPermissionWrapper> */}

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    {/* approval flow */}

                    {(activeTab === 'approval') && (

                        <div style={{ backgroundColor: '#F9FAFB', minHeight: 'auto' }}>
                            <div style={{
                                backgroundColor: '#fff',
                                marginTop: '30px',
                                borderRadius: '8px',
                                width: '100%',
                                height: '100%',
                                position: 'relative',

                            }}>
                                {/* Close Button */}
                                {/* <button
                                    onClick={() => setShowTimeline(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '20px',
                                        right: '20px',
                                        background: '#F9FAFB',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '50%',
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '18px',
                                        color: '#1F2937',
                                        cursor: 'pointer',
                                    }}
                                >
                                    ×
                                </button> */}

                                {/* Title */}
                                <h2 style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    marginBottom: '24px',
                                    color: '#111827',
                                }}>
                                    History : {approvalHistory.length}
                                </h2>

                                {/* Timeline */}
                                <div style={{ position: 'relative', paddingLeft: '30px' }}>
                                    {/* Vertical Line */}
                                    <div style={{
                                        position: 'absolute',
                                        top: '24px',
                                        left: '14px',
                                        width: '1px',
                                        height: 'calc(100% - 24px)',
                                        backgroundImage: 'linear-gradient(#D1D5DB 33%, rgba(209, 213, 219, 0) 0%)',
                                        backgroundPosition: 'right',
                                        backgroundSize: '2px 10px',
                                        backgroundRepeat: 'repeat-y',
                                    }} />

                                    {approvalHistory.length === 0 ? (
                                        <div>
                                            No approval history available
                                        </div>
                                    ) : (
                                        approvalHistory.map((item, index) => {
                                            const status = item.status?.toLowerCase();

                                            return (
                                                <div key={index} style={{ marginBottom: '40px', position: 'relative' }}>
                                                    {/* Icon */}
                                                    <div style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        backgroundColor:
                                                            status === 'approved' ? '#C1F7D7' :
                                                                status === 'rejected' ? '#FECACA' :
                                                                    status === 'submitted' ? '#DBEAFE' :
                                                                        status === 'cancel submitted' ? '#FEF3C7' :
                                                                            status === 'deleted' ? '#E5E7EB' :
                                                                                '#E5E7EB',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        position: 'absolute',
                                                        left: '-30px',
                                                        top: '12px',
                                                    }}>
                                                        {status === 'approved' ? (
                                                            <img style={{ width: '20px' }} src={tick_icon} alt="Approved" />
                                                        ) : status === 'rejected' ? (
                                                             <span style={{ color: '#DC2626', fontWeight: 'bold', marginTop: '6px' }}>×</span>
                                                        ) : status === 'submitted' ? (
                                                            <img style={{ width: '40px' }} src={submitted_icon} alt="Submitted" />
                                                        ) : (
                                                            <span style={{ color: '#4B5563' }}>...</span>
                                                        )}
                                                    </div>

                                                    {/* Content */}
                                                    <div style={{ marginLeft: '20px' }}>
                                                        <div style={{
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            color: '#19324C',
                                                            marginBottom: '4px',
                                                            textTransform: 'capitalize'
                                                        }}>
                                                            {item.status.toLowerCase() || 'Pending'}
                                                        </div>
                                                        <div style={{
                                                            fontSize: '14px',
                                                            color: '#19324C',
                                                            marginBottom: '2px',
                                                        }}>
                                                            {item.user_name || 'Unknown User'}
                                                        </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            color: '#9CA3AF'
                                                        }}>
                                                            {item.date_time || 'No date available'}
                                                        </div>
                                                        {item.comments && (
                                                            <div style={{
                                                                fontSize: '14px',
                                                                color: '#4B5563',
                                                                marginTop: '8px',
                                                                fontStyle: 'italic'
                                                            }}>
                                                                Comments: {item.comments}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <CommonFooter />
            <CommonRemarkPopup
                show={showRemarkPopup}
                onClose={() => setShowRemarkPopup(false)}
                onSave={handleSaveRemark}
                initialValue={remarkValue}
                title="Cost Remarks"
            />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default CostInvoiceViewPage
